/**
 * Componente SocialMediaLinks
 * Grupo de iconos de redes sociales
 */

import React from 'react';
import PropTypes from 'prop-types';
import SocialIcon from './SocialIcon';

/**
 * Contenedor de enlaces a redes sociales
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.links - Array de objetos con información de redes sociales
 * @param {string} props.className - Clases CSS adicionales
 * @returns {JSX.Element} Grupo de iconos sociales
 */
const SocialMediaLinks = ({ links, className = '' }) => {
  return (
    <div className={`flex space-x-4 ${className}`}>
      {links.map((link) => (
        <SocialIcon
          key={link.id}
          name={link.name}
          url={link.url}
          icon={link.icon}
        />
      ))}
    </div>
  );
};

SocialMediaLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default SocialMediaLinks;
